module.exports = __webpack_public_path__ + "img/logo-o6.ab3e3bbc.png";